import { UI_PRIMITIVE__button } from '@/components/ui/UI_PRIMITIVE__button';
import { use_hint_shortcut } from '@/hooks/hints_shortcut/use_hint_shortcut';
import { use_component_is_mounted_300 } from '@/hooks/is_mounted/use_component_is_mounted_300';
import { use_slice_ui, use_slice_user } from '@/hooks/store/use_slices';
import { ViewShortcutTrigger } from '@/pages/_base/shortcut_hint/ViewShortcutTrigger';
import { FN_USER_SETTINGS__update } from '@/utils/utils_client';
import { ENUM__grid2d_cell_size } from '@shared/dto/grid2d_cell/ENUM__grid2d_cell_size';
import { EShortcutType } from '@shared/dto/hint_shortcuts/e_shortcut_type';

export function GRID2D_BUTTON_change_cell_size() {
  /*
   * STORE
   */
  const { user_settings } = use_slice_user(['user_settings']);
  const { global__is_shift_pressed } = use_slice_ui(['global__is_shift_pressed']);

  /*
   * STATE
   */
  const { on_user_uses_shortcut, on_user_uses_component } = use_hint_shortcut(EShortcutType.GRID2D_BAR_DECREASE_CELL_SIZE);
  const { on_user_uses_component: on_user_uses_component_instead_scroll } = use_hint_shortcut(EShortcutType.GRID2D_CHANGE_CELL_SIZE_WITH_SCROLL);

  const { is_mounted } = use_component_is_mounted_300();

  /*
   * EVENTS
   */

  async function onClick() {
    let sizes = [ENUM__grid2d_cell_size.XS, ENUM__grid2d_cell_size.S, ENUM__grid2d_cell_size.M, ENUM__grid2d_cell_size.L, ENUM__grid2d_cell_size.XL];

    let index_current = sizes.indexOf(user_settings.ui_grid2d_cell_size);

    let index_next = global__is_shift_pressed ? index_current - 1 : index_current + 1;

    if (index_next < 0) index_next = sizes.length - 1;
    if (index_next >= sizes.length) index_next = 0;

    let size_new = sizes[index_next];

    await FN_USER_SETTINGS__update(user_settings.clone({ ui_grid2d_cell_size: size_new }));

    on_user_uses_component_instead_scroll();

    global__is_shift_pressed ? on_user_uses_shortcut() : on_user_uses_component();
  }

  /*
   * HTML
   */

  return (
    <ViewShortcutTrigger hint_shortcut_keys={[EShortcutType.GRID2D_BAR_DECREASE_CELL_SIZE]}>
      <UI_PRIMITIVE__button
        variant="no-border-on-bar"
        className={`p-0 flex items-center justify-center h-[28px] w-[30px]
      ${global__is_shift_pressed ? 'cursor-value-decrease' : 'cursor-value-increase'}`}
        {...{ onClick }}
      >
        <span className={`hover-animation ${is_mounted ? 'opacity-100 scale-100' : 'opacity-0 scale-50'}`}>{user_settings.ui_grid2d_cell_size}</span>
      </UI_PRIMITIVE__button>
    </ViewShortcutTrigger>
  );
}
